import { CampaignSignUpData, CampaignSignUpPayload } from "../signupViaCampaign.client";


export class ESGCampaignSignUpPayload extends CampaignSignUpPayload {
    constructor(signUpPayload: CampaignSignUpData) {
        signUpPayload.campaign = 'esg';
        super(signUpPayload);
    }
}